module.exports = __webpack_public_path__ + "img/outlook-icon.901b5e25.svg";